import { useToast } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export function ToastRouteGuard() {
  const toast = useToast();
  const location = useLocation();
  const toastId = 'ticket-toast';

  useEffect(() => {
    // If you leave ContactUs route, close the toast
    if (location.pathname !== '/contact-us' && toast.isActive(toastId)) {
      toast.close(toastId);
    }
  }, [location, toast]);

  return null; // nothing to render
}
